<template>
    <div class="page_container" v-loading="loading">
      <div class="form_box">
        <el-form size="small"   ref="currencyForm"   label-position="left"   label-width="140px"  :model="currencyForm"  :rules="currencyFormRules">
          <el-row :gutter="20" type="flex" class="flex_js_wrap" style="margin-left: 0!important;;margin-right: 0 !important;">
            <el-col  :span="23">
              <div class="title">基础信息</div>
            </el-col>

            <el-col  :span="13">
              <el-form-item label="微信小程序分享名" prop="share_touser_title">
                <el-input placeholder="请输入微信小程序分享名"   v-model="currencyForm.share_touser_title"></el-input>
              </el-form-item>
            </el-col>

<!--            <el-col  :span="13">-->
<!--              <el-form-item label="微信小程序logo" prop="wxapp_logo">-->
<!--                <div class="upload_img_wrap" >-->
<!--                  <div v-if="!currencyForm.wxapp_logo">-->
<!--                    <i class="el-icon-upload"></i>-->
<!--                    <div>点击上传</div>-->
<!--                  </div>-->
<!--                  <div class="upload_box">-->
<!--                    <input @change="handleChangeUpload($event,'wxapp_logo')" type="file" ref="inputUpload" accept="image/jpeg,image/png,image/gif">-->
<!--                    <img v-if="currencyForm.wxapp_logo" :src="currencyForm.wxapp_logo" alt="">-->
<!--                    <i @click="handleClickDelImage('wxapp_logo')" v-if="currencyForm.wxapp_logo" class="el-icon-delete"></i>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </el-form-item>-->
<!--            </el-col>-->
            <el-col  :span="13">
              <el-form-item label="微信小程序分享图" prop="share_touser_poster">
                <div class="upload_img_wrap" >
                  <div v-if="!currencyForm.share_touser_poster">
                    <i class="el-icon-upload"></i>
                    <div>点击上传</div>
                  </div>
                  <div class="upload_box">
                    <input @change="handleChangeUpload($event,'share_touser_poster')" type="file" ref="inputUpload" accept="image/jpeg,image/png,image/gif">
                    <img v-if="currencyForm.share_touser_poster" :src="currencyForm.share_touser_poster" alt="">
                    <i @click="handleClickDelImage('share_touser_poster')" v-if="currencyForm.share_touser_poster" class="el-icon-delete"></i>
                  </div>
                </div>
                <p style="font-size:12px;color:#666">图片大小：500*400 2M内</p>
              </el-form-item>
            </el-col>

            <el-col  :span="13">
              <el-form-item label="分享海报底部横幅" prop="share_poster_banner">
                <div class="upload_img_wrap" >
                  <div v-if="!currencyForm.share_poster_banner">
                    <i class="el-icon-upload"></i>
                    <div>点击上传</div>
                  </div>
                  <div class="upload_box">
                    <input @change="handleChangeUpload($event,'share_poster_banner')" type="file" ref="inputUpload" accept="image/jpeg,image/png,image/gif">
                    <img v-if="currencyForm.share_poster_banner" :src="currencyForm.share_poster_banner" alt="">
                    <i @click="handleClickDelImage('share_poster_banner')" v-if="currencyForm.share_poster_banner" class="el-icon-delete"></i>
                  </div>
                </div>
                <p style="font-size:12px;color:#666">图片大小：608*136 2M内</p>
              </el-form-item>
            </el-col>

            <el-col  :span="13">
              <el-form-item label="登录页面背景图" prop="login_background_image">
                <div class="upload_img_wrap" >
                  <div v-if="!currencyForm.login_background_image">
                    <i class="el-icon-upload"></i>
                    <div>点击上传</div>
                  </div>
                  <div class="upload_box">
                    <input @change="handleChangeUpload($event,'login_background_image')" type="file" ref="inputUpload" accept="image/jpeg,image/png,image/gif">
                    <img v-if="currencyForm.login_background_image" :src="currencyForm.login_background_image" alt="">
                    <i @click="handleClickDelImage('login_background_image')" v-if="currencyForm.login_background_image" class="el-icon-delete"></i>
                  </div>
                </div>
                <p style="font-size:12px;color:#666">图片大小：562*1218 2M内 需注意底部不可遮挡登录按钮 <a target="_blank" class="theme_color" href="https://download.hecoos.com/enlightv/2024-34/F5DPQKw3Q3F7SmZhmTrj.png">示例图</a></p>
              </el-form-item>
            </el-col>

            <el-col  :span="23">
              <div class="title">首页信息</div>
            </el-col>

            <el-col  :span="23">
              <el-form-item label="轮播图" prop="home_swiper_list">
                <ul class="upload_list">
                  <draggable v-model="currencyForm.home_swiper_list"  filter=".forbid" >
                    <li class="upload_img_wrap" v-for="(item,key) in currencyForm.home_swiper_list" :key="key">
                      <div class="upload_box">
                        <img  :src="item.file_path" alt="">
                        <i @click="handleClickDelFile(key)" v-if="item" class="el-icon-delete"></i>
                      </div>
                    </li>
                    <li class="upload_img_wrap forbid">
                      <div>
                        <i class="el-icon-upload"></i>
                        <div>点击上传</div>
                      </div>
                      <div class="upload_box">
                        <input @change="handleChangeUploadFiles" type="file" ref="inputUpload" multiple accept="image/jpeg,image/png,image/gif">
                      </div>
                    </li>
                  </draggable>

                </ul>
                <p style="font-size:12px;color:#666">图片大小：690*806 2M内</p>
              </el-form-item>
            </el-col>
            <el-col  :span="13">
              <el-form-item label="首页轮播底部横幅" prop="home_swiper_banner">
                <div class="upload_img_wrap" >
                  <div v-if="!currencyForm.home_swiper_banner">
                    <i class="el-icon-upload"></i>
                    <div>点击上传</div>
                  </div>
                  <div class="upload_box">
                    <input @change="handleChangeUpload($event,'home_swiper_banner')" type="file" ref="inputUpload" accept="image/jpeg,image/png,image/gif">
                    <img v-if="currencyForm.home_swiper_banner" :src="currencyForm.home_swiper_banner" alt="">
                    <i @click="handleClickDelImage('home_swiper_banner')" v-if="currencyForm.home_swiper_banner" class="el-icon-delete"></i>
                  </div>
                </div>
                <p style="font-size:12px;color:#666">图片大小：692*124 2M内</p>
              </el-form-item>
            </el-col>

            <el-col  :span="13">
              <el-form-item label="关于我们简介" prop="home_about_text">
                <el-input placeholder="请输入关于我们简介" type="textarea"  v-model="currencyForm.home_about_text"></el-input>
              </el-form-item>
            </el-col>
            <el-col  :span="13">
              <el-form-item label="经度" prop="latitude">
                <el-input placeholder="请输入经度"   v-model="currencyForm.latitude"></el-input>
              </el-form-item>
            </el-col>
            <el-col  :span="13">
              <el-form-item label="纬度" prop="longitude">
                <el-input placeholder="请输入纬度"   v-model="currencyForm.longitude"></el-input>
              </el-form-item>
            </el-col>
            <el-col  :span="13">
              <el-form-item label="地址" prop="home_addr">
                <el-input placeholder="请输入地址"   v-model="currencyForm.home_addr"></el-input>
              </el-form-item>
            </el-col>
            <el-col  :span="13">
              <el-form-item label="开馆日期" prop="open_museum_date">
                <el-input placeholder="请输入开馆日期"   v-model="currencyForm.open_museum_date"></el-input>
              </el-form-item>
            </el-col>
            <el-col  :span="13">
              <el-form-item label="开馆时间" prop="open_museum_time">
                <el-input placeholder="请输入开馆时间"   v-model="currencyForm.open_museum_time"></el-input>
              </el-form-item>
            </el-col>
            <el-col  :span="13">
              <el-form-item label="底部公司logo" prop="home_footer_logo">
                <div class="upload_img_wrap" >
                  <div v-if="!currencyForm.home_footer_logo">
                    <i class="el-icon-upload"></i>
                    <div>点击上传</div>
                  </div>
                  <div class="upload_box">
                    <input @change="handleChangeUpload($event,'home_footer_logo')" type="file" ref="inputUpload" accept="image/jpeg,image/png,image/gif">
                    <img v-if="currencyForm.home_footer_logo" :src="currencyForm.home_footer_logo" alt="">
                    <i @click="handleClickDelImage('home_footer_logo')" v-if="currencyForm.home_footer_logo" class="el-icon-delete"></i>
                  </div>
                </div>
                <p style="font-size:12px;color:#666">图片大小：180*136 2M内</p>
              </el-form-item>
            </el-col>

            <el-col  :span="23">
              <div class="title">关于我们</div>
            </el-col>
            <el-col  :span="13">
              <el-form-item label="关于我们海报" prop="about_poster">
                <div class="upload_img_wrap" >
                  <div v-if="!currencyForm.about_poster">
                    <i class="el-icon-upload"></i>
                    <div>点击上传</div>
                  </div>
                  <div class="upload_box">
                    <input @change="handleChangeUpload($event,'about_poster')" type="file" ref="inputUpload" accept="image/jpeg,image/png,image/gif">
                    <img v-if="currencyForm.about_poster" :src="currencyForm.about_poster" alt="">
                    <i @click="handleClickDelImage('about_poster')" v-if="currencyForm.about_poster" class="el-icon-delete"></i>
                  </div>
                </div>
                <p style="font-size:12px;color:#666">图片大小：662*1100 2M内</p>
              </el-form-item>
            </el-col>




            <el-col  :span="23">
              <div class="title">联系客服</div>
            </el-col>
            <el-col  :span="13">
              <el-form-item label="联系客服海报" prop="customer_service_poster">
                <div class="upload_img_wrap" >
                  <div v-if="!currencyForm.customer_service_poster">
                    <i class="el-icon-upload"></i>
                    <div>点击上传</div>
                  </div>
                  <div class="upload_box">
                    <input @change="handleChangeUpload($event,'customer_service_poster')" type="file" ref="inputUpload" accept="image/jpeg,image/png,image/gif">
                    <img v-if="currencyForm.customer_service_poster" :src="currencyForm.customer_service_poster" alt="">
                    <i @click="handleClickDelImage('customer_service_poster')" v-if="currencyForm.customer_service_poster" class="el-icon-delete"></i>
                  </div>
                </div>
                <p style="font-size:12px;color:#666">图片大小：662*1106 2M内</p>
              </el-form-item>
            </el-col>






          </el-row>
        </el-form>

      </div>

      <div class="button_box">
        <el-button size="small"   :disabled="btnDisabled" @click="handleClickConfirm" type="primary">保存</el-button>
      </div>
    </div>
</template>
<script>
    import { uploadImg ,getOSSData} from '@/utils/uploadOss'
    import {companyInfomationEdit, getCompanyDetail} from "../../../api";
    import draggable from 'vuedraggable'
    export default {
        name: 'basic_information',

        components: {
          draggable
        },
        data() {
            return {
              loading:false,
              currencyForm:{
                // wxapp_name:'',
                // wxapp_logo:'',
                share_touser_title:'',
                share_touser_poster:'',
                share_poster_banner:'', //生成海报的logo
                home_swiper_list:[],//轮播图
                home_swiper_banner:'',//轮播图下面的logo
                home_addr:'', //地址
                home_about_text:'',//关于我们的文案
                home_footer_logo:'', //底部logo
                latitude:'',// 经纬度
                longitude:'',
                open_museum_date: "", //开馆日期
                open_museum_time: "", //开馆时间
                about_poster:'', //关于我们
                customer_service_poster:'', //联系客服
                login_background_image:'', //登录页面背景图
              },
              currencyFormRules:{
                // wxapp_name:[{ required: true, message: '请输入小程序名称', trigger: 'blur'}],
                // wxapp_logo:[{ required: true, message: '请上传小程序logo', trigger: 'blur'}],
                share_touser_title:[{ required: true, message: '请输入小程序分享标题', trigger: 'blur'}],
                share_touser_poster:[{ required: true, message: '请上传小程序分享图', trigger: 'blur'}],
                share_poster_banner:[{ required: true, message: '请上传分享海报底部横幅', trigger: 'blur'}],
                home_swiper_list:[{ required: true, message: '请上传轮播图', trigger: 'blur'}],
                home_swiper_banner:[{ required: true, message: '请上传首页轮播底部横幅', trigger: 'blur'}],
                home_about_text:[{ required: true, message: '请输入关于我们简介', trigger: 'blur'}],
                home_addr:[{ required: true, message: '请输入地址', trigger: 'blur'}],
                latitude:[{ required: true, message: '请输入经度', trigger: 'blur'}],
                longitude:[{ required: true, message: '请输入纬度', trigger: 'blur'}],
                open_museum_date:[{ required: true, message: '请输入开馆日期', trigger: 'blur'}],
                open_museum_time:[{ required: true, message: '请输入开馆时间', trigger: 'blur'}],
                home_footer_logo:[{ required: true, message: '请上传首页公司底部logo', trigger: 'blur'}],
                about_poster:[{ required: true, message: '请上传关于我们海报', trigger: 'blur'}],
                customer_service_poster:[{ required: true, message: '请上传联系客服海报', trigger: 'blur'}],
                login_background_image:[{ required: true, message: '请上传登录页面背景图', trigger: 'blur'}],

              },
              btnDisabled:false
            }
        },
        mounted() {
          this.getCompanyDetail()
        },
        methods: {
          getCompanyDetail(){
            let postData = {}
            this.loading = true
            getCompanyDetail(postData).then(res => {
              if(res.code === 200){
                let {wxapp_name,share_touser_title,share_touser_poster,share_poster_banner,home_swiper_list,home_swiper_banner,home_addr,home_about_text,
                  home_footer_logo,latitude,longitude,open_museum_date,open_museum_time,about_poster,customer_service_poster,login_background_image} = res.data.company_infomation
                this.currencyForm.share_touser_title = share_touser_title ? share_touser_title:wxapp_name
                this.currencyForm.share_touser_poster = share_touser_poster
                this.currencyForm.share_poster_banner = share_poster_banner
                this.currencyForm.home_swiper_list = home_swiper_list
                this.currencyForm.home_swiper_banner = home_swiper_banner
                this.currencyForm.home_addr = home_addr
                this.currencyForm.home_about_text = home_about_text
                this.currencyForm.home_footer_logo = home_footer_logo
                this.currencyForm.latitude = latitude
                this.currencyForm.longitude = longitude
                this.currencyForm.open_museum_date = open_museum_date
                this.currencyForm.open_museum_time = open_museum_time
                this.currencyForm.about_poster = about_poster
                this.currencyForm.customer_service_poster = customer_service_poster
                this.currencyForm.login_background_image = login_background_image
              }
              this.loading = false
            }).catch(() => {
              this.loading = false
            })
          },


          handleClickConfirm(){
            this.$refs.currencyForm.validate(valid => {
              if (valid) {
                this.btnDisabled = true
                let postData = this.currencyForm

                companyInfomationEdit(postData).then(res => {
                  if(res.code === 200){
                    this.$message({
                      message: '编辑成功',
                      type: 'success',
                      duration: 1500,
                      onClose: () => {
                        this.btnDisabled = false

                      }
                    });
                  }
                }).catch(() => {
                  this.btnDisabled = false
                })

              } else {
                return false
              }
            })
          },


          handleChangeUpload(event,type){
            var file = event.target.files[0];
            uploadImg(file,2).then(res => {
              this.$message.success('上传成功')
              this.currencyForm[type] = res.file_path
              this.$refs.currencyForm.clearValidate(type)
            }).catch(() => {
              this.loading = false
            })
          },
          handleClickDelImage(type){
            this.currencyForm[type] = ''
          },


          // 上传轮播图
          handleChangeUploadFiles(event){
            var file = event.target.files;
            var arr = []
            for (var i in file) {
              arr.push(file[i]);
            }
            arr.forEach((item)=>{
              if(item.size){
                uploadImg(item,2).then(res => {
                  this.$message.success('上传成功')
                  this.currencyForm.home_swiper_list.push({file_path:res.file_path})
                  this.$refs.currencyForm.clearValidate('home_swiper_list')
                }).catch(() => {
                  this.loading = false
                })
              }

            })
          },
          // 删除轮播图
          handleClickDelFile(key){
            this.currencyForm.home_swiper_list.splice(key,1)
          },


        },
    }
</script>
<style lang="scss" scoped>
.page_container{

  padding-bottom: 66px;
  box-sizing: border-box;
  position: relative;
}
.form_box{
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
.button_box{
  position: absolute;
  width: 100%;
  padding: 6px 24px;
  box-shadow: 0px 3px 5px rgba(0,0,0,.3);
  left: 0;
  bottom: 0;
  background: #fff;
  text-align: right;
}
.title{
  line-height: 24px;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 16px;
  padding-left: 8px;
  position: relative;
  &:before{
    width: 3px;
    height: 14px;
    content: ' ';
    left: 0;
    top: 50%;
    margin-top: -7px;
    position: absolute;
    border-radius: 3px;
    background: #1990FF;
  }
}

.upload_img_wrap {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  box-sizing: border-box;
  width: 150px;
  height: 150px;
  text-align: center;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: all .3s;
}
.upload_img_wrap:hover {
  color:#409EFF;
  border-color: #409EFF;
}
.upload_img_wrap:hover .el-icon-upload {
  color: #409EFF;
}
.upload_img_wrap .el-icon-upload {
  font-size: 40px;
  color: #c0c4cc;
  margin: 35px 0 10px;
  transition: all .3s;
}
.upload_box {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  line-height: 150px;
}
.upload_box img {
  height: 90%;
  width: 90%;
  margin: 5%;
  z-index: 55;
  box-sizing: border-box;
  display: block;
  object-fit: cover_image;
}
.upload_box video {
  height: 90%;
  width: 90%;
  margin: 5%;
  z-index: 55;
  box-sizing: border-box;
  display: block;
  object-fit: cover_image;
}
.upload_box .el-icon-delete {
  position: absolute;
  right: 0;
  top: 0;
  font-size: 20px;
  border: 1px solid #c2c2c2;
  border-radius: 50%;
  z-index: 300;
  cursor: pointer;
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: #fff;
}
.upload_box input {
  width: 100%;
  display: block;
  height: 100%;
  z-index: 20;
  opacity: 0;
  cursor: pointer;
  position: absolute;
  left: 0;
  top: 0;
}
.upload_list{
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
}
.upload_list>div{
  display: flex;
  flex-wrap: wrap;

}
.upload_list li{
  padding: 0;
  margin: 0;
  margin-right: 10px;
  margin-bottom: 20px;
  position: relative;
  overflow: inherit;
}
</style>
